import script from "./submitProposalModal.vue?vue&type=script&setup=true&lang=js"
export * from "./submitProposalModal.vue?vue&type=script&setup=true&lang=js"

import "./submitProposalModal.vue?vue&type=style&index=0&id=6412d5a3&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6412d5a3"]])

export default __exports__